import InfiniteScroll from 'react-infinite-scroll-component'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

import TreeNode from '../tree-node'

const shouldRenderNode = (node, searchModeOn, data) => {
  if (searchModeOn || node.expanded) return true

  const parent = node._parent && data.get(node._parent)
  // if it has a parent, then check parent's state.
  // otherwise root nodes are always rendered
  return !parent || parent.expanded
}

class Tree extends Component {
  static propTypes = {
    data: PropTypes.object,
    keepTreeOnSearch: PropTypes.bool,
    keepChildrenOnSearch: PropTypes.bool,
    searchModeOn: PropTypes.bool,
    onChange: PropTypes.func,
    onNodeToggle: PropTypes.func,
    onAction: PropTypes.func,
    onCheckboxChange: PropTypes.func,
    simpleSelect: PropTypes.bool,
    showPartiallySelected: PropTypes.bool,
    pageSize: PropTypes.number,
    nodeRenderer: PropTypes.func,
    iconRenderer: PropTypes.func,
    readOnly: PropTypes.bool,
    noItemsPlaceholder: PropTypes.any
  }

  static defaultProps = {
    pageSize: 100,
    noItemsPlaceholder: <p>The data contains no valid elements for display</p>
  }

  constructor(props) {
    super(props)

    this.computeInstanceProps(props)

    this.state = {
      items: this.allVisibleNodes.slice(0, this.props.pageSize)
    }
  }

  componentWillReceiveProps = nextProps => {
    this.computeInstanceProps(nextProps)
    this.setState({ items: this.allVisibleNodes.slice(0, this.props.pageSize) })
  }

  componentDidMount = () => {
    this.setState({
      scrollableTarget: this.node && this.node.parentNode
        ? this.node.parentNode
        : null
    })
  }

  computeInstanceProps = props => {
    this.allVisibleNodes = this.getNodes(props)
    this.totalPages = Math.ceil(this.allVisibleNodes.length / this.props.pageSize)
    this.currentPage = 1
  }

  hasValidData = data => {
    return data && data.constructor === Map
      ? data.size > 0
      : false
  }

  getNodes = props => {
    const {
      data,
      keepTreeOnSearch,
      searchModeOn,
      simpleSelect,
      showPartiallySelected,
      readOnly,
      nodeRenderer,
      iconRenderer,
      onAction,
      onChange,
      onCheckboxChange,
      onNodeToggle,
      keepChildrenOnSearch
    } = props
    const items = []
    if (this.hasValidData(data)) {
      data.forEach(node => {
        if (shouldRenderNode(node, searchModeOn, data)) {
          items.push(<TreeNode
            keepTreeOnSearch={keepTreeOnSearch}
            keepChildrenOnSearch={keepChildrenOnSearch}
            key={node._id}
            {...node}
            searchModeOn={searchModeOn}
            onChange={onChange}
            onCheckboxChange={onCheckboxChange}
            onNodeToggle={onNodeToggle}
            onAction={onAction}
            simpleSelect={simpleSelect}
            showPartiallySelected={showPartiallySelected}
            nodeRenderer={nodeRenderer}
            iconRenderer={iconRenderer}
            readOnly={readOnly}
          />)
        }
      })
    }
    return items
  }

  hasMore = () => this.currentPage <= this.totalPages

  loadMore = () => {
    this.currentPage = this.currentPage + 1
    const nextItems = this.allVisibleNodes.slice(0, this.currentPage * this.props.pageSize)
    this.setState({ items: nextItems })
  }

  setNodeRef = node => {
    this.node = node
  }

  render() {
    const {
      searchModeOn,
      noItemsPlaceholder
    } = this.props
    const { items } = this.state
    const hasItems = items.length > 0

    return hasItems
      ? <ul className={`root ${searchModeOn ? 'searchModeOn' : ''}`} ref={this.setNodeRef}>
        {this.state.scrollableTarget && (
          <InfiniteScroll
            dataLength={this.state.items.length}
            next={this.loadMore}
            hasMore={this.hasMore()}
            loader={null}
            scrollableTarget={this.state.scrollableTarget}
          >
            {this.state.items}
          </InfiniteScroll>
        )}
      </ul>
      : noItemsPlaceholder
  }
}

export default Tree
